import React from 'react'

function Footer() {
  return (
    <div className='justify-center text-center mt-[5rem] bg-gray-800 p-5' >
       <h1 className=' text-xl font-semibold text-gray-400'> Made by HARSHAL with ❤️</h1>
      
    </div>
  )
}
export default Footer;
